<template>
  <div class="home_root">
    <pc-only
      v-loading="loadding"
      class="pc_root"
    >
      <div class="home flex1">
        <div class="right_ctn">
          <div class="home_content flex">
            <div class="left flex">
              <div class="top_data flex">
                <div class="realtime_overview">
                  <span class="title">实时概况</span>
                  <span class="des">当天数据，更新时间：{{ (new Date().getTime())| formatTime("yyyy-MM-dd hh:mm:ss") }}</span>
                </div>
                <div class="realtime_orderlist flex">
                  <ul class="list_name flex">
                    <li
                      v-for="(item,index) in orderList"
                      :key="index"
                      class="flex"
                    >
                      <div class="name">
                        {{ item.title }}
                      </div>
                      <div class="num">
                        {{ item.data_area_num }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="new_orderlist">
                <div class="realtime_overview">
                  <span class="title">最新订单动态</span>
                  <span class="des">最关键的信息</span>
                </div>
                <div class="order_status">
                  <div class="dqr flex status_item">
                    <div class="name">
                      待确认
                    </div>
                    <count-to
                      :start-val="0"
                      :end-val="orderListData.BuyerWaitingSellerConfirm || 0"
                      :duration="2000"
                      class="num"
                    />
                  </div>
                  <div class="dfh flex status_item">
                    <div class="name">
                      待发货
                    </div>
                    <count-to
                      :start-val="0"
                      :end-val="orderListData.WaitingSendGoods || 0"
                      :duration="2000"
                      class="num"
                    />
                  </div>
                  <div class="tksh flex status_item">
                    <div class="name">
                      退款/售后
                    </div>
                    <count-to
                      :start-val="0"
                      :end-val="orderListData.WaitingRefund ||0"
                      :duration="2000"
                      class="num"
                    />
                  </div>
                </div>
              </div>
              <div class="new_orderlist flex">
                <div class="realtime_overview">
                  <span class="title">待修改供应</span>
                  <span class="des"><el-button
                    type="text"
                    class="all"
                    @click="toSupplyList"
                  >查看全部</el-button></span>
                  <!-- <span @click="toPublish"> -->
                  <el-button
                    size="mini"
                    class="publish"
                    @click="toPublish"
                  >
                    发布供应
                  </el-button>
                <!-- </span> -->
                </div>
                <template v-if="supplyList.length">
                  <div
                    v-for="(item,index) in supplyList"
                    :key="index"
                    :class="{'border': index<supplyList.length-1}"
                    class="content_list flex"
                  >
                    <div class="up flex">
                      <div class="left_content">
                        <img
                          src="http://img.yimutian.com/misc/5cb45e835c26555cbd1695367cfbca1d.png"
                          alt="图片"
                        >
                      </div>
                      <div class="right_content">
                        <div class="title">
                          {{ item.title }}
                        </div>
                        <div class="price">
                          ¥{{ item.price }}
                        </div>
                      </div>
                      <div class="toEdit">
                        <el-button
                          type="text"
                          class="edit"
                          @click="toEdit(item.supply_id)"
                        >
                          去修改
                        </el-button>
                      </div>
                    </div>
                    <div class="bottom_content">
                      <div class="tips tipBg flex">
                        <img
                          src="http://img.yimutian.com/misc/5d11badb7960423e1117515167620336.png"
                          alt=""
                          class="tipBg"
                        >{{ item.refuse_reason }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="no_data flex">
                    <img
                      src="http://img.yimutian.com/misc/5d12dd267960423e1117e8fd300139b9.png"
                      alt=""
                    >
                    <span class="font14">暂无内容~</span>
                  </div>
                </template>
              </div>
              <div class="new_orderlist flex">
                <div class="realtime_overview">
                  <span class="title">当月收入趋势（元）</span>
                  <span class="des">当天数据，更新时间：{{ (new Date().getTime())| formatTime("yyyy-MM-dd hh:mm:ss") }}</span>
                </div>
                <div
                  ref="echarts"
                  :style="{width: echartswidth,height: '200px'}"
                  class="echarts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </pc-only>
  </div>
</template>

<script>
import { Message, MessageBox } from 'element-ui'
import { mapGetters } from 'vuex'
import { helper } from '@ymt/gfw-axios'
import { home, orderList, supply } from '@/api'
import menuIcon from '@/filters/menu_icon'
import countTo from 'vue-count-to'
const echarts = require('echarts')
export default {
  filters: {
    menuIcon
  },
  components: {
    countTo
  },
  data() {
    return {
      // portrait: '',
      // username: '',
      // phone: '',
      // regDate: '',
      orderList: [
        {
          // name: '30天客户联系数',
          // num: '0'
        },
        {
          // name: '30天浏览量',
          // num: '0'
        },
        {
          // name: '累计交易金额',
          // num: '0'
        },
        {
          title: '7天下单数',
          data_area_num: '0'
        },
        {
          title: '7天交易金额',
          data_area_num: '0'
        }
      ],
      creditValue: 0,
      degValue: -180,
      orderListData: {},
      echartswidth: '100%',
      amount: 0,
      dateList: [],
      incomeList: [],
      loadding: true,
      supplyList: []
    }
  },
  computed: {
    ...mapGetters({
      menuHistory: 'authorizedHistory'
    })
  },
  created() {
    // 所欲数据请求完成再渲染
    Promise.all([
      // this.getUserinfo(),
      this.getList(),
      this.getSupplyList(2, 2),
      this.getSupplyList(1, 100),
      this.getIncomeStats(3),
      this.getOrderStats(2),
      this.sellerData()
    ]).then((res) => {
      this.loadding = false
    }).catch(e => {
      this.loadding = false
    })
  },
  mounted() {
    this.echartswidth = '100%'
  },
  methods: {
    // getUserinfo() {
    //   return home.getUserinfo().then(({ data }) => {
    //     if (data.status === 0) {
    //       this.portrait = data.data.portrait
    //       this.username = data.data.user_name
    //       this.phone = data.data.mobile
    //       this.regDate = data.data.regDate
    //     }
    //   })
    // },
    // 退出
    logout() {
      MessageBox.confirm('确定退出登录?', '', {
        showCancelButton: true
      })
        .then(action => {
          home.logout().then(({ data }) => {
            if (data.status === 0) {
              helper.clearSid()
              this.$router.push({ name: 'login' })
            }
          })
        })
        .catch(() => {})
    },
    getcurrentMonth() {
      let month = (new Date()).getMonth() + 1 // 获取当前月
      let data = []
      let dataLength = new Date().getDate()
      for (let i = 0; i < dataLength; i++) {
        data.push(month + '.' + (i + 1) + '日')
      }
      return data
    },
    initEchart() {
      let myChart = echarts.init(this.$refs.echarts)
      let option = {
        grid: {
          top: '20',
          left: '20',
          right: '20',
          bottom: '20',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLine: { // 坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              color: ' #636363',
              width: 2
            }
          },
          boundaryGap: true,
          data: this.dateList,
          axisLabel: { // 坐标轴刻度标签的相关设置
            textStyle: {
              color: '#9B9B9B',
              fontSize: 12
            }
          }
        },
        itemStyle: { normal: { label: { show: true, position: 'top' } } },
        yAxis: {
          type: 'value',
          axisPointer: { show: true, type: 'none', label: { show: true }, snap: true },
          axisTick: { show: false },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#DDD'
            }
          }
        },
        series: [{
          data: this.incomeList,
          type: 'line',
          smooth: true,
          showAllSymbol: true,
          color: '#00ac8b',
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(17,221,214,0.3)' },
                { offset: 1, color: 'rgba(0,172,139,0)' }
              ], false),
              shadowColor: 'rgba(53,142,215, 0.9)',
              shadowBlur: 20
            }
          }

        }]
      }
      myChart.setOption(option)
    },
    getIncomeStats(type) {
      let year = (new Date()).getFullYear() // 获取当前月
      let month = (new Date()).getMonth() // 获取当前月
      let startTime = new Date(year, month, 1).getTime() / 1000 // 当月1号时间戳
      let param = {
        access_token: 'access_token',
        data: {
          // customer_id: 0,
          type: type, // 月营收分析
          start_time: startTime // 1月，月份代表
        }
      }
      return home.incomestats(param).then(({ data }) => {
        if (data.status === 0) {
          data.data.incomes_by_day.forEach((v) => {
            let val = v.split(':')
            this.dateList.push(val[0])
            this.incomeList.push(val[1])
          })
          setTimeout(() => {
            this.initEchart()
          }, 0)
        }
      })
    },
    getOrderStats(type) {
      let startTime = parseInt((new Date().getTime() - 24 * 7 * 60 * 60 * 1000) / 1000)
      let endTime = parseInt(new Date().getTime() / 1000)// 当天时间戳
      let param = {
        access_token: 'access_token',
        data: {
          // customer_id: 0,
          type: type, // 日营收分析
          start_time: startTime, //
          end_time: endTime // 今天时间
        }
      }
      return home.orderstats(param).then(({ data }) => {
        if (data.status === 0) {
          // this.orderList[1].num = data.data.created_order_buyer_cnt
          this.orderList[3].data_area_num = data.data.created_order_cnt
          this.orderList[4].data_area_num = data.data.total_amt
        }
      })
    },
    getList() {
      let postData = {
      }
      return orderList.getList({
        access_token: 'accessToken',
        data: {
          ...postData,
          user_type: 6, // 6 卖家，7 买家
          count: 10
        }
      })
        .then(({ data: res }) => {
          if (res.status === 0) {
            this.orderListData = res.data.statistics
          } else {
            Message.info({
              message: res.msg || '获取列表失败'
            })
          }
        })
    },
    getSupplyList(onsale, pageSize) {
      return supply.getList({ onSale: onsale, pageStart: 0, pageSize: pageSize }).then(({ data }) => {
        if (data.status === 0) {
          if (Number(onsale) === 2 && Number(pageSize) === 2) {
            this.supplyList = data.list
          }
        }
      })
    },
    sellerData() {
      return home.sellerData({}).then(({ data }) => {
        try {
          let result = data.result[1].nodes[1].nodes
          this.orderList[0] = result[1].displayDesc
          this.orderList[1] = result[0].displayDesc
          this.orderList[2] = result[2].displayDesc
        } catch (e) {}
      })
    },
    toSupplyList() {
      this.$router.push({ name: 'supplyList', params: { typeId: 1031 } })
    },
    toPublish() {
      this.$router.push({ name: 'publishSupply' })
    },
    toEdit(id) {
      this.$router.push({ name: 'editSupply', params: { supplyId: id } })
    }
  },
}
</script>
<style lang="less" scoped>
@import '../assets/lib.less';
.home_root {
  height: 100%;
  background-color: #f2f2f2;
}
.phone_only {
  .avatar {
    width: 140 / @rem;
    height: 140 / @rem;
    margin-right: 16 / @rem;
  }
  .avatar_txt {
    width: 140 / @rem;
    height: 140 / @rem;
    line-height: 140 / @rem;
    text-align: center;
    font-size: 64 / @rem;
    background-color: #d0d0d0;
    margin-right: 16 / @rem;
    color: #fff;
  }
  .v_middle {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .page_title {
    margin: 24 / @rem;
    font-size: 36 / @rem;
  }
  .card {
    padding: 24 / @rem;
    margin: 24 / @rem;
    background-color: #fff;
    border-radius: 04 / @rem;
    .username {
      font-size: 36 / @rem;
    }
    .phone {
      font-size: 24 / @rem;
      color: #999;
      height: 32 / @rem;
      line-height: 32 / @rem;
    }
    .red_date {
      font-size: 24 / @rem;
      color: #999;
      height: 32 / @rem;
      line-height: 32 / @rem;
    }
    .logout_btn {
      font-size: 28 / @rem;
      color: #999;
      height: 140 / @rem;
      line-height: 140 / @rem;
      padding: 0 24 / @rem;
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    }
  }
  .history_item {
    text-decoration: none;
    font-size: 28 / @rem;
    color: #333;
    .item_icon {
      max-width: 28 / @rem;
      max-height: 28 / @rem;
      margin-right: 12 / @rem;
    }
  }
}
.pc_only {
  .pc_root {
    // margin: 20px 16px;
  }
  .history_item {
    width: 96px;
    line-height: 20px;
    text-decoration: none;
    font-size: 16px;
    color: #333;
    display: inline-block;
    text-align: center;
    background-color: #fff;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 6px;
    padding: 12px;
    box-sizing: border-box;
    .item_icon {
      max-width: 48px;
      max-height: 48px;
      vertical-align: text-bottom;
    }
    .item_label {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  ul,li{
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .right_ctn{
    .home_content{
      .left{
        flex: 1;
        flex-direction: column;
        .realtime_overview{
            .title{

              font-size: 0.16rem;
              color: #333333;
              text-align: center;
              padding-right: 0.1rem;
            }
            .des{

              font-size: 0.14rem;
              color: #999999;
            }
          }
        .top_data{
          background: #ffffff;
          height: 1.56rem;
          padding: 0.2rem;
          box-sizing: border-box;
          flex-direction: column;
          .realtime_orderlist{
            padding: 0.21rem 0.20rem 0.20rem 0rem;
            // margin-left: -0.3rem;
            ul{
              flex: 1;
              li{
                flex-direction: column;
                flex: 1;
                text-align: center;
                .name{

                  font-size: 0.14rem;
                  color: #999999;
                }
                .num{
                  font-family: PingFangSC-Semibold;
                  font-size: 0.28rem;
                  padding-top: 0.10rem;
                  color: #333333;
                }
              }
            }
          }
        }
        .new_orderlist{
          background: #ffffff;
          margin-top: 0.21rem;
          flex-direction: column;
          .realtime_overview{
            padding: 0.2rem 0.2rem 0 0.2rem
          }
          .order_status{
            flex: 1;
            padding: 0.2rem;
            padding: 0.20rem 0.65rem 0.30rem 0.65rem;
            flex: 1;
            flex-direction: row;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
          }
          .dqr{
            background-image: linear-gradient(180deg, #03A4C3 0%, #06CDAC 100%);
            box-shadow: 2px 2px 7px 0 rgba(3,92,57,0.20);
          }
          .dfh{
            background-image: linear-gradient(180deg, #A151FF 0%, #DC9FFF 100%);
            box-shadow: 2px 2px 7px 0 rgba(59,0,120,0.20);
            margin: 0 0.3rem;
          }
          .tksh{
            background-image: linear-gradient(179deg, #378DFF 0%, #ABD8FF 100%);
            box-shadow: 2px 2px 7px 0 rgba(0,87,185,0.20);
          }
          .status_item{
            flex: 1;
            max-width: 1.8rem;
            height: 1.24rem;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            font-size: 0.14rem;
            color: #FFFFFF;
            text-align: center;
            transition: all .5s ease;
            .num{
              font-size: 0.28rem;
            }
            &:hover{
            transform:scale(1.1);
          }
          }
          .publish{
              float:right;
              text-align: center;
              line-height: 0.3rem;
              width: 0.8rem;
              height: 0.3rem;
              background: #00AC8B;
              border-radius: 2px;

              font-size: 12px;
              color: #FFFFFF;
          }
          .border{
            border-bottom:1px solid #DEDEDE;
          }
          .content_list{
            flex-direction: column;
            margin: 0 0.2rem;
            padding: 0.2rem 0;
            .up{
              padding-bottom: 0.13rem;
            }
            .left_content img{
              width: 0.7rem;
              height: 0.7rem;
              padding-right: 0.1rem;
            }
            .right_content{
              .title{
                width: 2.38rem;
                height: 0.4rem;
                padding: 0.06rem 0;
                font-size: 0.14rem;
                color: #333333;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                box-sizing: border-box;
              }
              .price{
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FF4F01;
                padding-top: 6px;
              }
            }
            .toEdit{
              float: right;
              flex: 1;
              text-align: right;
              padding: 0.06rem 0.2rem;
            }
            .bottom_content{
              height:0.3rem;
              display: flex;
              align-items: center;
              border-radius: 2px;
              line-height: 20px;
              img{
                width: 0.14rem;
                height: 0.14rem;
                padding: 0 4px 0 0;
              }
              .tips{
              font-size: 14px;
              color: #F43530;
              opacity: 1;
              justify-content: center;
              align-items: center;
              background: rgba(244,53,48,0.06);
              padding: 5px;
              }
            }
          }
          .no_data{
            height: 227px;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
              width: 70px;
              height: 70px;
            }
            span{
              color: #333333;
              text-align: center;
            }
          }
        }
      }
      .el-button{
        padding: 0;
      }
      .absulute{
        position: absolute;
      }
      .right{
        margin-left: 0.2rem;
        width: 3.6rem;
        .top_content{
          position: relative;
          flex:1;
          height: 1.76rem;
          background-image: linear-gradient(180deg, #03A4C3 0%, #06CDAC 100%);
          .circleImg{
            position: relative;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            height: 100%;
            img{
              width: 3.26rem;
              height: 1.62rem;
            }
            .floatImg{
              width: 2.8rem;
              height: 1.41rem;
              position: absolute;
              left: 0.31rem;
              top: 0.35rem;
              transform: rotate(-180deg);
              transform-origin: bottom;
              transition: all 3s cubic-bezier(0, 0, 0, 0.96);
            }
          }
          .creditValue{
            width: 100%;
            height: 50px;
            display: table-cell;
            justify-content: center;
            text-align: center;
            color: #ffffff;
            top: 50%;
            left: 0;
            margin-left: -5px;
            vertical-align: middle;
            .value{
              font-size: 0.48rem;
            }
            .levon{
              font-size: 0.16rem;
            }
          }
        }
        .star_content{
          background: #ffffff;
          .star_list{
            color: #333333;
            align-items: center;
            padding: 0.14rem 0.3rem 0rem 0.2rem;
            .attribute{
              width: 100px;
            }
          }
          .star_img {
            padding-left: 0.12rem;
            img{
            width: 0.20rem;
            height: 0.20rem;
            padding-right: 0.04rem;
          }
          }
          .starlevel{
            text-align: right;
            flex: 1;
          }
        }
        .des_content{
          background: #ffffff;
          padding: 0.24rem 0.30rem 0.2rem 0.2rem;
          p{
            color: #666666;
          }
        }
        .last_active{
          padding: 0.2rem;
          background: #ffffff;
          .active_list{
            position: relative;
            width: 3.2rem;
            height: 1.1rem;
            margin-top: 0.1rem;
            img{
              width: 100%;
              height: 100%;
            }
            .mask{
              width: 100%;
              height: 100%;
              line-height: 1.1rem;
              text-align: center;
              position: absolute;
              top: 0;
              left: 0;
              color: #ffffff;
              background: rgba(0,0,0,0.69)
            }
          }
        }
        .font16{
          font-size: 0.16rem;
        }
        .font14{
          font-size: 0.14rem;
        }
        .Semibold{
          font-family: PingFangSC-Semibold;
        }
        .Medium{

        }
        .height20{
          height: 0.2rem;
          width: 100%;
        }
      }
    }
  }
}
</style>
